module.exports = __webpack_public_path__ + "media/PAG89-07.8ad8e364.mp3";